import ActionPanel from '@components/layout/action-panel/ActionPanel';
import Main from '@components/layout/main/Main';
import RightPanel from '@components/layout/right-panel/RightPanel';
import Sidebar from '@components/layout/sidebar/Sidebar';
import { useWindowSize } from '@hooks';
import { useChatStore } from '@store/chat';
import { useMemo } from 'react';

function MainPage() {
  const hasStartedChat = useChatStore((state) => state.hasStartedChat());
  const windowSize = useWindowSize();

  const actionPanel = useMemo(
    () => (hasStartedChat || !windowSize.isLarge ? <ActionPanel /> : null),
    [hasStartedChat, windowSize.isLarge]
  );

  return (
    <>
      <Sidebar />
      {actionPanel}
      <Main />
      <RightPanel />
    </>
  );
}

export default MainPage;
